import { AppRoutes } from "@/shared/lib/routes"
import { createRoute } from "@tanstack/react-router"
import { Suspense, useMemo } from "react"
import { rootRoute } from "./__root"
import { resolveCheckoutVariant } from "@/features/payments"
import { useConfig } from "@/features/config"
import { LoadingSpinner } from "@/shared/components/loading-spinner"

export const checkoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: AppRoutes.CHECKOUT,
  component: CheckoutPage,
})

function CheckoutPage() {
  // Effective params merge the funnel config with live URL params (URL wins),
  // recomputed once the config lands so the resolved variant updates with it.
  const { params } = useConfig()
  const effectiveParams = useMemo(() => {
    const merged: Record<string, string> = { ...params }
    if (typeof window !== "undefined") {
      new URLSearchParams(window.location.search).forEach((value, key) => {
        merged[key] = value
      })
    }
    return merged
  }, [params])

  const { Component } = useMemo(() => resolveCheckoutVariant(effectiveParams), [effectiveParams])

  return (
    <Suspense
      fallback={
        <div className="flex min-h-[100dvh] items-center justify-center bg-dark-base">
          <LoadingSpinner />
        </div>
      }
    >
      <Component />
    </Suspense>
  )
}
